import { Grid, useMediaQuery } from "@material-ui/core";
import React from "react";
import { logoURL } from "./Constants";
import CopyrightView from "./CopyrightView";
import useStyles from "./Styles";

const MapView = () => {
  const classes = useStyles();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <Grid
      sm={6}
      xs={12}
      item
      container
      justify="center"
      alignContent="center"
      className={classes.rightContent}
    >
      <img
        src={logoURL["map"]}
        alt="map"
        height="96%"
        className={classes.image}
      />
      {matches && (
        <Grid item container justify="flex-end" alignContent="flex-end">
          <CopyrightView />
        </Grid>
      )}
    </Grid>
  );
};

export default MapView;
